import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Register = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const result = await register(formData);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Join GlowFlex</h1>
        <p style={styles.subtitle}>Create your account and start your fitness journey</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Full Name</label>
            <input
              type="text"
              required
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              style={styles.input}
              placeholder="Your Name"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input
              type="email"
              required
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              style={styles.input}
              placeholder="your@email.com"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Phone</label>
            <input
              type="tel"
              required
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              style={styles.input}
              placeholder="0712345678"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              type="password"
              required
              minLength="6"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              style={styles.input}
              placeholder="Minimum 6 characters"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Confirm Password</label>
            <input
              type="password"
              required
              value={formData.confirmPassword}
              onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
              style={styles.input}
              placeholder="Re-enter password"
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{width: '100%', padding: '1rem'}}>
            Sign Up
          </button>
        </form>

        <p style={styles.switchText}>
          Already have an account? <Link to="/login" style={styles.link}>Login</Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: { maxWidth: '500px', margin: '4rem auto', padding: '0 2rem' },
  card: { background: 'white', padding: '3rem', borderRadius: '20px', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' },
  title: { fontSize: '2.5rem', textAlign: 'center', marginBottom: '0.5rem', fontFamily: 'Playfair Display, serif' },
  subtitle: { textAlign: 'center', color: '#5A5A5A', marginBottom: '2rem' },
  formGroup: { marginBottom: '1.5rem' },
  label: { display: 'block', fontWeight: 600, marginBottom: '0.5rem' },
  input: { width: '100%', padding: '0.875rem', border: '2px solid #ddd', borderRadius: '12px', fontSize: '1rem' },
  error: { background: '#f8d7da', color: '#721c24', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' },
  switchText: { textAlign: 'center', marginTop: '1.5rem', color: '#5A5A5A' },
  link: { color: '#FFA8B9', fontWeight: 600, textDecoration: 'none' }
};

export default Register;